interface AbiInput {
  name: string;
  type: string;
  indexed?: boolean;
  internalType?: string;
}

interface AbiItem {
  type: string;
  name?: string;
  inputs?: AbiInput[];
  outputs?: AbiInput[];
  stateMutability?: string;
  anonymous?: boolean;
}

/**
 * Extracts an event ABI from a contract ABI by event name
 * @param contractAbi - The full contract ABI
 * @param eventName - The name of the event to extract
 * @returns The event ABI item or null if not found
 */
export function getEventAbi(contractAbi: AbiItem[], eventName: string): AbiItem | null {
  const eventAbi = contractAbi.find((item) => item.type === 'event' && item.name === eventName);
  return eventAbi || null;
}

/**
 * Extracts event inputs for decoding logs
 * @param contractAbi - The full contract ABI
 * @param eventName - The name of the event
 * @returns Array of event input parameters for web3.eth.abi.decodeLog
 */
export function getEventInputsForDecoding(contractAbi: AbiItem[], eventName: string): AbiInput[] {
  const eventAbi = getEventAbi(contractAbi, eventName);
  if (!eventAbi || !eventAbi.inputs) {
    throw new Error(`Event ${eventName} not found in contract ABI`);
  }
  return eventAbi.inputs;
}
